import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import Axios from '../helpers/Interceptor'

const IS_MOCK = true
const MAESTRO_INSTAGRAM_POSTS_MOCK_DATA = {
    "username": "nafeesisboujee",
    "profileData": {
        "followers": 80234,
        "postsCount": 129
    },
    "analyzedPosts": [
        {
            "postMetadata": {
                "caption": "Stephanie is my teacher 😲?!? #fyp #stevelacy #beabadoobee #newmusic #music #artist",
                "username": "nafeesisboujee",
                "timestamp": "2025-02-06T19:25:18+0000",
                "permalink": "https://www.instagram.com/reel/DFviRR_SrlB/",
                "engagement": 220969
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video starts with a blurred shot of a classroom. It transitions to a clear shot of a young man sitting at a desk, surrounded by crumpled paper. He is wearing a pink and maroon striped sweater. He gestures expressively with his hands as the audio plays. Posters are on the peeling blue and brick walls of the classroom.",
                    "visual_elements": [
                        "Classroom setting",
                        "Crumpled paper",
                        "Posters on the wall",
                        "Close-up of the artist",
                        "Casual attire (striped sweater)",
                        "Hand gestures",
                        "Overhead fluorescent lighting",
                        "Visible wear and tear on the classroom walls and furniture"
                    ],
                    "themes_topics": [
                        "School life",
                        "Music creation",
                        "Nostalgia",
                        "Student artist struggles",
                        "Relatability",
                        "Making music while being a student"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Teens and young adults (15-22)",
                        "High school and college students",
                        "Globally focused, especially in English-speaking countries"
                    ],
                    "psychographics": [
                        "Aspiring musicians and artists",
                        "Value authenticity and relatability",
                        "Engage with DIY and bedroom pop culture",
                        "Experience the challenges of balancing school and creative passions",
                        "Active on social media, particularly TikTok and Instagram",
                        "Interested in niche music genres"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "Clairo",
                        "Bedroom pop artists",
                        "Indie music labels",
                        "DIY music influencers"
                    ],
                    "topics": [
                        "Bedroom pop music",
                        "Student artists",
                        "DIY music production",
                        "Relatable school struggles",
                        "Indie music scene",
                        "Social media music trends",
                        "Creative expression",
                        "Music education",
                        "Emerging artists",
                        "Steve Lacy"
                    ]
                },
                "detailed_summary": "This video captures the relatable struggle of a student artist balancing creative pursuits with academic obligations. The classroom setting, combined with the artist's expressive gestures and casual attire, creates an intimate and authentic feel. The peeling walls and crumpled paper further highlight the theme of imperfection and the everyday grind. The caption indicates the user feels it's crazy how they make music but still have to go to school. The video targets young individuals engaged in artistic expression while navigating school life. Marketing efforts should leverage the authentic and relatable aspects of the video to connect with aspiring musicians and creative students who face similar challenges.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "we made it to billboard 🫶 love u guys :) #fyp #newmusic #stevelacy #beabadoobee #laufey #artist",
                "username": "nafeesisboujee",
                "timestamp": "2025-01-25T18:40:57+0000",
                "permalink": "https://www.instagram.com/reel/DFQku2ESLeC/",
                "engagement": 192214
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video shows a young man, presumably in a classroom setting, reacting to the news that his song has charted on Billboard. He is seen sitting at a desk, with snippets of a laptop screen showing the Billboard charts, including the artist's name and song title at position #23. The video captures his surprised and happy reaction to this achievement, with the caption indicating that it was an unexpected yet welcome surprise.",
                    "visual_elements": [
                        "POV style video",
                        "Close-up shots of the creator's face to capture emotional response",
                        "Classroom setting with desks and chairs",
                        "Laptop screen displaying Billboard charts",
                        "Casual attire suggesting student lifestyle",
                        "Low lighting, indicating indoor setting",
                        "Text overlay with 'POV' and a description of the scenario",
                        "Use of surprised and happy emojis"
                    ],
                    "themes_topics": [
                        "Success in music industry",
                        "Unexpected achievement",
                        "Relatable student life",
                        "Music charts recognition",
                        "DIY music promotion",
                        "Gen Z content creation"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Gen Z (16-24 years old)",
                        "Students (high school or college)",
                        "Aspiring musicians and artists",
                        "Music enthusiasts",
                        "Urban and suburban residents"
                    ],
                    "psychographics": [
                        "Value authenticity and relatability",
                        "Interested in emerging artists and indie music",
                        "Active on social media, particularly TikTok and Instagram",
                        "Dream of achieving success in creative fields",
                        "Follow music trends and charts",
                        "Appreciate DIY music promotion",
                        "Engage with content related to student life"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "Laufey",
                        "Billboard",
                        "Spotify",
                        "Apple Music"
                    ],
                    "topics": [
                        "Indie pop",
                        "Bedroom pop",
                        "DIY music production",
                        "Billboard charts",
                        "Gen Z music trends",
                        "Student life",
                        "Social media promotion for musicians",
                        "Music industry success stories",
                        "Emerging artists",
                        "Viral music trends on TikTok"
                    ]
                },
                "detailed_summary": "This Instagram reel captures a relatable moment of a young musician discovering their song has charted on Billboard while in class, conveying surprise and excitement. The video's authentic and spontaneous feel, combined with its connection to trending artists like Steve Lacy and Beabadoobee, will resonate with Gen Z audiences interested in emerging music talent and the behind-the-scenes realities of achieving success in the music industry. The user-generated content style and relatable context of discovering news in class make the content feel authentic and engaging, which can be leveraged in marketing efforts to promote relatability and community among aspiring musicians and fans.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "I can't escape stephanie, or this song 💔 #fyp #stevelacy #beabadoobee #newmusic #music #artist",
                "username": "nafeesisboujee",
                "timestamp": "2025-02-10T20:15:41+0000",
                "permalink": "https://www.instagram.com/reel/DF58PH6hxQ8/",
                "engagement": 165587
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video shows a person lip-syncing and reacting to a song while walking through a grand, public building that looks like a train station. Text overlays appear on the screen, showing the lyrics of the song. The video then transitions to a text message notification appearing on the screen, humorously referencing a person named 'Stephanie'.",
                    "visual_elements": [
                        "Interior of a grand, public building with high ceilings and architectural details",
                        "Person wearing a black sweatshirt with a devil graphic and glasses",
                        "Use of text overlays for song lyrics and humorous commentary",
                        "American flag",
                        "Smartphone notification graphic mimicking a text message",
                        "Slightly blurry camera movement",
                        "Casual attire"
                    ],
                    "themes_topics": [
                        "Relationship troubles",
                        "Steve Lacy's music",
                        "Public spaces",
                        "Emotional expression through music",
                        "Text message humor",
                        "Reacting to music",
                        "Relatable content"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Ages 16-25",
                        "Gen Z",
                        "Urban residents",
                        "Social media users",
                        "Smartphone users"
                    ],
                    "psychographics": [
                        "Interested in current music trends",
                        "Use humor to cope with relationship problems",
                        "Active on social media",
                        "Value relatable content",
                        "Engage with meme-style content",
                        "Expressive and emotional",
                        "Appreciate aesthetic visuals"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "Similar musical artists in the indie/alternative genre",
                        "Relatable meme accounts on Instagram and TikTok"
                    ],
                    "topics": [
                        "Steve Lacy",
                        "Relatable memes",
                        "Relationship advice",
                        "Heartbreak songs",
                        "Public places as backgrounds",
                        "Gen Z humor",
                        "Social media trends",
                        "React videos",
                        "New music discovery",
                        "Alternative music"
                    ]
                },
                "detailed_summary": "This Instagram reel features a person emotionally lip-syncing to a popular song by Steve Lacy, walking in what appears to be a train station. The caption expresses a sense of being unable to escape both 'Stephanie' and the song, suggesting relationship troubles. The video uses relatable humor with a text message notification to enhance the viewer's engagement. It is tailored to a young adult audience that enjoys meme-style content, reacts to popular music, and can relate to relationship problems. This content could be used in marketing campaigns that target Gen Z and younger millennials who are active on social media and keen on sharing emotional experiences.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "bro really made a video💀 music video out now 🫶 #fyp #newmusic #music #stevelacy #beabadoobee #artist #stephanie",
                "username": "nafeesisboujee",
                "timestamp": "2025-02-21T21:31:21+0000",
                "permalink": "https://www.instagram.com/reel/DGWZsokP2ZB/",
                "engagement": 123307
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video opens with a person working on math problems in a textbook at a desk. The scene transitions to a shot of the same person singing in front of a brick wall. The video then shows a person, presumably a teacher, yelling at the camera as papers fly around. It cuts to a shot of multiple young people dancing. The text overlay reads 'no way bro made a music video for this song.' The caption provided also indicates it is a promotion for a new music video.",
                    "visual_elements": [
                        "Textbook with math problems",
                        "Hand writing with a pencil",
                        "Brick wall background",
                        "Person singing with hair down",
                        "Teacher yelling at camera",
                        "Flying papers",
                        "Group of young people dancing",
                        "Fast cuts and transitions",
                        "Casual attire",
                        "Bedroom setting"
                    ],
                    "themes_topics": [
                        "Music video creation",
                        "DIY music production",
                        "Student life and stress",
                        "Gen Z humor",
                        "Indie music promotion",
                        "Relatability to academic struggles",
                        "Creative expression"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "16-24 years old",
                        "Students (high school and college)",
                        "Gender-neutral",
                        "Urban and suburban areas",
                        "English-speaking countries"
                    ],
                    "psychographics": [
                        "Interest in indie music and emerging artists",
                        "Value authenticity and relatability",
                        "Appreciate humor and meme culture",
                        "Engaged in social media and online trends",
                        "Experience academic stress and seek creative outlets",
                        "Aspire to express themselves artistically",
                        "Support DIY and independent creators"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "Other indie/bedroom pop artists",
                        "Student influencers",
                        "DIY music blogs and channels"
                    ],
                    "topics": [
                        "Indie music",
                        "Bedroom pop",
                        "DIY music production",
                        "Student life",
                        "Academic stress",
                        "Music videos",
                        "Gen Z humor",
                        "Relatable content",
                        "TikTok trends",
                        "Viral challenges"
                    ]
                },
                "detailed_summary": "This Instagram Reel promotes a new music video using humor and relatable visuals of student life. It combines scenes of academic stress with shots of the artist performing and people enjoying the music, appealing to Gen Z's taste for DIY creativity and authenticity. The content strategy should leverage the contrast between the mundane and the artistic, emphasizing the music's ability to provide an escape from everyday struggles. Marketing efforts should target online communities interested in indie music, student life, and relatable comedic content, encouraging user-generated content using the music as a soundtrack.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "W or L aura?!? 😭 #fyp #stevelacy #beabadoobee #newmusic #music #stephanie #artist",
                "username": "nafeesisboujee",
                "timestamp": "2025-02-24T19:34:54+0000",
                "permalink": "https://www.instagram.com/reel/DGd6v_HPIU6/",
                "engagement": 105945
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video opens with the creator in Times Square asking viewers how many 'aura points' they gained for being there. They are wearing a casual outfit, including a pink hoodie and jacket, and glasses. The video then transitions to a Times Square billboard featuring a YouTube Shorts advertisement. The ad showcases the creator 'Nafeesisboujee' and the song 'Stephanie' alongside promotions for 'Create Your Take' and related themes.",
                    "visual_elements": [
                        "Bright, eye-catching advertisement on a large Times Square billboard.",
                        "Personal selfie-style video with the creator in focus.",
                        "Casual, Gen Z fashion (pink hoodie, glasses, necklace).",
                        "Dynamic urban environment of Times Square with cars and pedestrians.",
                        "Text overlay asking about 'aura points'.",
                        "YouTube Shorts branding and interface elements."
                    ],
                    "themes_topics": [
                        "Aura points and self-perception",
                        "New music promotion",
                        "Social media validation",
                        "Music artist appreciation (Steve Lacy, Beabadoobee)",
                        "Gen Z culture",
                        "Times Square and urban settings",
                        "YouTube Shorts content",
                        "User-generated content and participation"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Ages 16-24",
                        "Likely urban residents",
                        "Gen Z",
                        "Social media users, particularly Instagram and YouTube Shorts",
                        "Potentially students or young professionals"
                    ],
                    "psychographics": [
                        "Values social validation and online presence",
                        "Interested in music, particularly indie and alternative",
                        "Follows current fashion trends",
                        "Engages with meme culture and online challenges",
                        "Aspires to be seen as cool and trendy",
                        "Active participants in online communities",
                        "Seeks relatable and authentic content"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "YouTube Shorts",
                        "Popular Instagram and TikTok influencers",
                        "Fashion brands targeting Gen Z"
                    ],
                    "topics": [
                        "Aura points and self-image",
                        "Gen Z humor and memes",
                        "Indie and alternative music",
                        "Social media trends",
                        "Urban exploration and city life",
                        "User-generated content",
                        "Fashion and personal style",
                        "YouTube Shorts challenges",
                        "Music promotion on social media"
                    ]
                },
                "detailed_summary": "This Instagram reel features a Gen Z content creator seeking validation for being in Times Square, framed by the concept of 'aura points,' while also showcasing a YouTube Shorts ad featuring their content. The video targets young, social media-savvy individuals who are interested in music, fashion, and urban culture. Marketing strategies could leverage user-generated content trends, promote emerging music artists, and engage audiences through interactive questions and challenges, emphasizing the blend of personal identity and social media presence.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "Stephanie did not want these flowers 💔 #fyp #stevelacy #newmusic #beabadoobee #music #artist #stephanie",
                "username": "nafeesisboujee",
                "timestamp": "2025-02-23T19:02:46+0000",
                "permalink": "https://www.instagram.com/reel/DGbSTvjP4R_/",
                "engagement": 99687
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video shows a person walking through a snowy urban area, specifically near the Washington Square Arch in New York City. They are carrying a bouquet of red roses. Throughout the video, text overlays appear on the screen, indicating the roses are for someone named Stephanie. The narrative unfolds as it becomes clear that Stephanie did not want the flowers, adding a humorous and self-deprecating twist to the story.",
                    "visual_elements": [
                        "Urban setting with snow",
                        "Washington Square Arch in the background",
                        "Red roses in a bouquet",
                        "Person wearing a North Face puffer jacket, glasses, and a pearl necklace",
                        "Text overlays with the phrases 'definitely', 'I', and 'like Stephanie'",
                        "Vertical video format typical of TikTok and Instagram Reels"
                    ],
                    "themes_topics": [
                        "Rejection",
                        "Unrequited love",
                        "Indie pop music",
                        "Music trends on social media",
                        "Relatable relationship issues",
                        "Humor",
                        "Self-deprecating content"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Gen Z (16-24 years old)",
                        "Primarily urban residents",
                        "Likely students or young professionals",
                        "Gender-inclusive, but potentially leaning slightly towards female",
                        "Located in or interested in New York City"
                    ],
                    "psychographics": [
                        "Interested in indie pop and alternative music",
                        "Active on social media platforms like TikTok and Instagram",
                        "Value humor and relatable content",
                        "Fashion-conscious and follow current trends",
                        "Experience or appreciate the nuances of modern dating",
                        "Open to expressing vulnerability and sharing personal experiences online"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "The North Face",
                        "Ralph Lauren",
                        "Influencers who create relatable and comedic content"
                    ],
                    "topics": [
                        "Indie pop music",
                        "TikTok trends",
                        "Instagram Reels",
                        "Dating and relationships",
                        "Rejection and heartbreak",
                        "NYC culture",
                        "Gen Z humor",
                        "Fashion trends (puffer jackets, pearl necklaces)",
                        "Winter in the city",
                        "Self-deprecating humor"
                    ]
                },
                "detailed_summary": "This Instagram reel features a person humorously dealing with rejection, as indicated by the caption \"Stephanie did not want these flowers.\" The video's charm lies in its relatable and self-deprecating portrayal of unrequited love, set against the backdrop of a snowy New York City. The use of a trending song (implied by the Steve Lacy and beabadoobee hashtags) and the integration of modern fashion elements like the pearl necklace and North Face jacket, make it appealing to a younger, trend-conscious audience. The content is perfect for brands looking to tap into the Gen Z sense of humor and their affinity for authentic, relatable content. It can be used to leverage targeted advertising for brands related to fashion, music, or even dating apps, focusing on the shared experience of dealing with rejection in a lighthearted manner.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "cmon guys, Stephanie is still MASSIVE 😭 #fyp #newmusic #music #artist #stevelacy #beabadoobee #stephanie",
                "username": "nafeesisboujee",
                "timestamp": "2025-02-17T19:22:11+0000",
                "permalink": "https://www.instagram.com/reel/DGL3vBmSHmR/",
                "engagement": 48276
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video features different people walking towards the camera in an urban environment. The text overlay says, 'pov: this song is still massive'. The backgrounds vary with snow and brick walls. The audio is of the song \"Stephanie\" by Steve Lacy, the popular song referenced.",
                    "visual_elements": [
                        "Urban backgrounds (city streets, brick walls)",
                        "Snowy conditions in some clips",
                        "Everyday attire, casual clothing",
                        "Text overlay",
                        "First-person perspective"
                    ],
                    "themes_topics": [
                        "Popular song recognition",
                        "Relatability",
                        "Urban setting",
                        "Fashion",
                        "Millennial/Gen Z culture",
                        "Street style"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Ages 16-28",
                        "Gen Z and younger Millennial demographic",
                        "Urban dwellers",
                        "Globally distributed, primarily English-speaking regions"
                    ],
                    "psychographics": [
                        "Interested in new music and popular music trends",
                        "Active on social media, particularly TikTok and Instagram",
                        "Value humor and relatable content",
                        "Interested in fashion and street style",
                        "Engaged with meme culture",
                        "Likely to follow music influencers and artists like Steve Lacy and Beabadoobee",
                        "Appreciate content that feels authentic and reflects their daily life experiences"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "Popular music meme accounts",
                        "Fashion brands popular among Gen Z"
                    ],
                    "topics": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "Stephanie (song)",
                        "TikTok trends",
                        "Instagram Reels",
                        "Indie pop",
                        "Music memes",
                        "Gen Z humor",
                        "Urban fashion",
                        "Viral sounds"
                    ]
                },
                "detailed_summary": "This user-generated content capitalizes on the ongoing popularity of the song \"Stephanie\" by Steve Lacy. The repetitive use of the song in different scenarios suggests that it is still very popular in the digital consciousness. The video targets an audience familiar with the song and the 'POV' meme format, mostly Gen Z and Millennial viewers. The inclusion of #beabadoobee and the caption's reference to \"MASSIVE\" also helps to target people interested in indie music and the artists mentioned. A marketing strategy should focus on music trends, short video format trends, and targeting the audience who loves the indie and pop artists that are mentioned.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "this song #fyp #newmusic #stevelacy #artist #stephanie #beabadoobee #laufey #music",
                "username": "nafeesisboujee",
                "timestamp": "2024-12-21T19:26:56+0000",
                "permalink": "https://www.instagram.com/reel/DD2iLUpSANH/",
                "engagement": 40566
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "A young man is seen outside on a sunny day, wearing glasses and a white sweater. He smiles and appears to be lip-syncing or singing along to music. The location appears to be an urban environment with brick walkways and trees. The focus is on the individual's enjoyment of the music and the pleasant outdoor setting.",
                    "visual_elements": [
                        "Close-up shot of a young man with glasses",
                        "Sunny outdoor lighting",
                        "Urban setting with brick walkways and buildings",
                        "Casual attire: white Ralph Lauren sweater",
                        "Natural, unfiltered aesthetic",
                        "Trees and greenery in the background"
                    ],
                    "themes_topics": [
                        "Indie Pop Music",
                        "Bedroom Pop Aesthetic",
                        "New Music Discovery",
                        "Youthful Expression",
                        "Casual Style",
                        "Sunny Urban Environment"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Ages 16-24",
                        "Gender-neutral appeal",
                        "Urban residents",
                        "Students or young professionals"
                    ],
                    "psychographics": [
                        "Interested in indie and alternative music",
                        "Value authentic and relatable content",
                        "Follow music trends on TikTok and Instagram",
                        "Appreciate casual, comfortable fashion",
                        "Seek new music discoveries"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "Laufey",
                        "Clairo",
                        "Rex Orange County"
                    ],
                    "topics": [
                        "Indie pop",
                        "Bedroom pop",
                        "New music",
                        "TikTok music trends",
                        "Casual fashion",
                        "Urban lifestyle",
                        "Gen Z culture",
                        "Music discovery",
                        "Alternative music"
                    ]
                },
                "detailed_summary": "This Instagram reel features a young man enjoying indie-pop music in a sunny urban setting. The casual style and emphasis on new music align with Gen Z trends. The content appeals to those interested in discovering new artists and enjoying simple, aesthetically pleasing visuals. Marketing should focus on promoting the music featured and leveraging influencers within the indie-pop community.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "she keeps on texting me 🤷🏽‍♂️ #fyp #newmusic #stephanie #stevelacy #newartist #music",
                "username": "nafeesisboujee",
                "timestamp": "2024-10-26T18:08:26+0000",
                "permalink": "https://www.instagram.com/reel/DBmMn6oS0DB/",
                "engagement": 35257
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video features a young man standing outdoors in front of a stone wall with archways, possibly on a college campus. He lip-syncs and dances to a song with the lyrics, 'she keeps on texting me.' Text overlay appears showing a comment asking 'Who's Hailey?!' and the lyrics of the song. His outfit consists of a multi-colored knit sweater, dark pants, and black loafers. His expressions convey a mix of confusion and nonchalance.",
                    "visual_elements": [
                        "Pastel-colored knit sweater (blue, pink, white)",
                        "Dark pants",
                        "Black loafers",
                        "Outdoor setting with stone archways",
                        "Natural lighting",
                        "Text overlay with lyrics and comments",
                        "Expressive facial expressions (confusion, nonchalance)",
                        "Casual dance moves",
                        "Glasses"
                    ],
                    "themes_topics": [
                        "New music promotion",
                        "Relationship issues/Texting",
                        "Bedroom pop/Indie music",
                        "College/University life",
                        "Social media trends/Dancing",
                        "Steve Lacy influence",
                        "Nostalgia and relatability"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Age 16-24",
                        "Gender-inclusive",
                        "Students (high school or college)",
                        "Urban or suburban areas",
                        "English-speaking countries (US, UK, Canada, Australia)"
                    ],
                    "psychographics": [
                        "Interested in indie pop and alternative music",
                        "Active on social media (TikTok, Instagram)",
                        "Values relatable content and humor",
                        "Fashion-conscious (casual, trendy)",
                        "Interested in relationship dynamics and social interactions",
                        "Open to discovering new artists",
                        "Appreciates bedroom pop aesthetic",
                        "Engaged with meme culture"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Omar Apollo",
                        "Clairo",
                        "beabadoobee",
                        "TikTok influencers",
                        "Indie music labels"
                    ],
                    "topics": [
                        "Bedroom pop",
                        "Indie music",
                        "New music releases",
                        "Relationship problems",
                        "Texting etiquette",
                        "College life",
                        "Social media trends",
                        "Viral dances",
                        "Music promotion on social media",
                        "Alternative R&B"
                    ]
                },
                "detailed_summary": "This Instagram reel showcases a young male artist promoting his new music using a relatable scenario about persistent texting. The video blends elements of music promotion with social media trends like lip-syncing and dancing. The pastel sweater and outdoor university-like setting create a youthful, approachable vibe. The reference to 'Stephanie' and the inquiry about 'Hailey' adds a layer of intrigue, potentially sparking conversation and engagement. The artist's use of relevant hashtags such as #fyp, #newmusic, #stevelacy, #newartist, and #music helps to target a specific audience interested in new indie/bedroom pop music influenced by artists like Steve Lacy. To further leverage these insights, the artist could engage directly with comments, use similar visuals in future posts, and create content that delves deeper into the storyline hinted at in the video.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "this song #fyp #music #stevelacy #beabadoobee #artist #laufey #newmusic",
                "username": "nafeesisboujee",
                "timestamp": "2025-01-03T18:56:09+0000",
                "permalink": "https://www.instagram.com/reel/DEX8_NOypct/",
                "engagement": 32584
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video features a young person sitting in a park, seemingly enjoying a relaxed day outdoors. They are surrounded by trees and other park-goers in the background. Text overlay appears on the screen, suggesting a contemplation or commentary on relationships and personal feelings. The overall atmosphere is calm and reflective.",
                    "visual_elements": [
                        "A young person sitting on the grass in a park.",
                        "Casual attire: sweater, dark pants, and dress shoes.",
                        "Golden hour lighting creating a warm and inviting atmosphere.",
                        "Text overlay expressing introspective thoughts.",
                        "Background with people enjoying the park, trees, and a distant building.",
                        "Soft focus and slightly desaturated colors to evoke a nostalgic feel."
                    ],
                    "themes_topics": [
                        "Relaxed vibes and introspection",
                        "Appreciation of music and aesthetics",
                        "Exploration of youthful emotions and relationships",
                        "Fashion and personal style expression",
                        "Day in the park, casual social gatherings"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "16-24 years old",
                        "Likely students or young professionals",
                        "Urban residents",
                        "Gender-inclusive",
                        "English-speaking regions"
                    ],
                    "psychographics": [
                        "Interested in indie and alternative music",
                        "Value emotional expression and authenticity",
                        "Appreciate relaxed and casual aesthetics",
                        "Engage in introspective thinking and share personal feelings",
                        "Active on social media and follow trends in music and fashion",
                        "Value outdoor activities and social gatherings in public spaces",
                        "Likely to use social media for music discovery"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "Laufey",
                        "Clairo",
                        "Boy Pablo",
                        "Rex Orange County"
                    ],
                    "topics": [
                        "Indie pop music",
                        "Alternative R&B",
                        "Bedroom pop",
                        "Youth culture",
                        "Urban parks and recreation",
                        "Casual fashion",
                        "Personal style",
                        "Relationship thoughts",
                        "Aesthetic social media content",
                        "Golden hour photography"
                    ]
                },
                "detailed_summary": "This Instagram reel captures a tranquil moment in a park, blending music appreciation with youthful introspection on relationships. The setting, casual fashion, and accompanying text suggest a target audience of young adults who value aesthetics, emotional expression, and relatable content. The mention of artists like Steve Lacy and Beabadoobee in the caption positions the content within a specific music subculture, while the location implies an urban, nature-loving audience. Marketing could leverage this by highlighting similar chill vibes, curating music playlists, and partnering with fashion brands that align with the subject's style.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "STEPHANIE MUSIC VIDEO OUT NOW ON YOUTUBE ❤️🤍 LOVE YOU GUYS\n\ndirected & edited by kirchfilmss \nwritten by kogohome\n\nexecutive producer: thomascarmona production manager: carleylovitooo director of photography: evanmillerdp\n1st ad: claydealy\n1st ac: maxotg\ngaffer: colegrove666 \nkey grip: dardopamine \nswing: alecmaskell \nart director: hayjims \ncasting director: anayaford \nstylist: pk333\neditor: kirchfilmss \ncolorist: ricardospdp\n3d: hrapavastr \nkey pa: demetrispiros \ndriver pa: trane.wreck \ndriver pa: redcobra67\npa: ryan_spiro1722",
                "username": "nafeesisboujee",
                "timestamp": "2025-02-19T23:43:31+0000",
                "permalink": "https://www.instagram.com/reel/DGRfCBRPcfD/",
                "engagement": 13576
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video appears to be a music video with scenes set in school and home environments. A student is shown doodling in class, followed by scenes of a group of friends dancing and celebrating, interspersed with shots of the singer performing in a bedroom setting.",
                    "visual_elements": [
                        "Classroom setting with a textbook and a student drawing.",
                        "Diverse group of young people dancing and having fun.",
                        "Close-up shots of expressive faces, especially smiles and singing.",
                        "Bedroom with posters, a bookshelf, and personal items creating a youthful vibe.",
                        "Warm and vibrant color grading enhancing the energy of the scenes.",
                        "Fast-paced editing conveying excitement and dynamism."
                    ],
                    "themes_topics": [
                        "Music video",
                        "School life",
                        "Friendship",
                        "Youthful exuberance",
                        "Creative expression",
                        "Contemporary R&B"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Gen Z (16-24 years old)",
                        "High school and college students",
                        "Urban and suburban youth",
                        "Gender-inclusive"
                    ],
                    "psychographics": [
                        "Interested in music and pop culture",
                        "Value friendship and social connections",
                        "Expressive and creative individuals",
                        "Engaged in social media trends",
                        "Appreciate authentic and relatable content",
                        "Seek positive and uplifting experiences"
                    ],
                    "public_figures_brands": [
                        "Contemporary R&B artists popular with Gen Z",
                        "Indie music labels and artists",
                        "Brands targeting youth culture",
                        "Educational and lifestyle influencers"
                    ],
                    "topics": [
                        "New music releases",
                        "School-related content",
                        "Friendship goals",
                        "DIY music videos",
                        "Gen Z trends",
                        "Teen culture",
                        "Emerging artists",
                        "Social media challenges",
                        "Student life",
                        "R&B music scene"
                    ]
                },
                "detailed_summary": "This Instagram Reel seems to be a promotional snippet for a music video, blending school-themed visuals with vibrant celebrations of youth and friendship. The video's high energy and focus on expressive performances are tailored to engage a younger demographic interested in contemporary music and relatable experiences. The use of dynamic editing and warm color grading enhances its appeal to a Gen Z audience, making it an ideal piece for targeted advertising on platforms frequented by this group. The school theme combined with musical performance broadens the appeal, suggesting a blend of academic relatability and aspirational artistic expression.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "she keeps on _____ 🤔#fyp #stevelacy #beabadoobee #newmusic #music #artist",
                "username": "nafeesisboujee",
                "timestamp": "2025-03-01T19:42:31+0000",
                "permalink": "https://www.instagram.com/reel/DGqzhtYvbNJ/",
                "engagement": 10528
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video shows a person riding an escalator in what appears to be a train station. The person lip-syncs to a song, and text overlays appear on the screen referencing Stephanie and suggesting a shared inside joke or action. The video uses snippets of popular songs by Steve Lacy and Beabadoobee.",
                    "visual_elements": [
                        "Escalator in a public transport hub, possibly Grand Central Station, due to architectural style.",
                        "Person wearing a graphic sweatshirt with a devil design, glasses, and a necklace.",
                        "Text overlays indicating actions or phrases linked to the audio.",
                        "Background featuring commuters and architectural details.",
                        "Casual attire suggests a relaxed, everyday setting."
                    ],
                    "themes_topics": [
                        "Music trends",
                        "Gen Z humor",
                        "Referential content",
                        "Popular song snippets",
                        "Escalator rides",
                        "Social interactions"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Gen Z (16-24 years old)",
                        "Urban dwellers",
                        "Likely students or young professionals",
                        "English-speaking audience"
                    ],
                    "psychographics": [
                        "Interested in music trends and indie artists",
                        "Active on social media, particularly TikTok and Instagram",
                        "Value humor and relatable content",
                        "Engaged in internet culture and meme trends",
                        "Appreciate quick, easily digestible content",
                        "Likely to share content with friends that reflects inside jokes or shared experiences"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "Accounts that curate trending sounds",
                        "Brands that engage in meme marketing",
                        "Popular Gen Z influencers"
                    ],
                    "topics": [
                        "TikTok trends",
                        "Instagram Reels",
                        "Indie pop music",
                        "Gen Z humor",
                        "Meme culture",
                        "Viral challenges",
                        "Music-related content",
                        "Short-form video content",
                        "Relatable everyday moments",
                        "Social media trends"
                    ]
                },
                "detailed_summary": "The video is a short, trendy clip that uses popular music snippets and Gen Z humor to create relatable content. The focus is on a shared experience or inside joke related to a person named Stephanie. The setting in a public space like Grand Central adds an element of everyday life, making the content more accessible. To leverage this for marketing, brands could incorporate trending sounds and relatable scenarios, creating short, shareable content that taps into niche internet humor and references.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "Stephanie got a billboard in Times Square 🫶 love y'all so much, changed my life and forever grateful ❤️ #fyp #newmusic #music #stevelacy #beabadoobee youtube youtubemusic",
                "username": "nafeesisboujee",
                "timestamp": "2025-02-13T18:41:56+0000",
                "permalink": "https://www.instagram.com/reel/DGBfssTSJNK/",
                "engagement": 9718
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video shows a person standing in Times Square, New York City, filming a billboard that features their artist name 'Nafeesisboujee' and their song 'Stephanie'. The billboard also features the YouTube Shorts logo and a QR code. The person expresses excitement and gratitude in the video, reflecting on how their music made in their bedroom led to this achievement.",
                    "visual_elements": [
                        "Times Square billboards",
                        "YouTube Shorts advertisement",
                        "Artist's name 'Nafeesisboujee'",
                        "Song title 'Stephanie'",
                        "QR code for YouTube Music",
                        "Urban setting",
                        "Crowd of people in Times Square",
                        "Person filming with a smartphone",
                        "Pink and white striped sweater",
                        "Statement belt",
                        "Daytime lighting"
                    ],
                    "themes_topics": [
                        "Success Story",
                        "Music Promotion",
                        "Times Square Billboard",
                        "Bedroom Producer",
                        "Dreams Come True",
                        "Social Media Success",
                        "Grateful Artist",
                        "YouTube Music",
                        "New Music"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Ages 16-28",
                        "Gen Z",
                        "Urban dwellers",
                        "Aspiring musicians",
                        "Social media users",
                        "US and UK based"
                    ],
                    "psychographics": [
                        "Believe in the power of social media",
                        "Dreamers with a strong desire for success",
                        "Interested in music and the arts",
                        "Value authenticity and originality",
                        "Tech-savvy",
                        "Inspired by success stories",
                        "Follow trending music and artists"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "YouTube Music",
                        "Spotify",
                        "TikTok influencers",
                        "Emerging R&B/Soul artists"
                    ],
                    "topics": [
                        "R&B/Soul music",
                        "DIY music production",
                        "Social media marketing for musicians",
                        "Independent artists",
                        "Bedroom pop",
                        "Music industry trends",
                        "YouTube Shorts marketing",
                        "Times Square",
                        "Emerging artists",
                        "Dreams coming true"
                    ]
                },
                "detailed_summary": "This Instagram Reel captures the excitement of a musician seeing their name and song on a Times Square billboard, a significant milestone in their career. The video promotes the artist Nafeesisboujee and their song Stephanie, highlighting the power of social media, particularly YouTube, in achieving success. The content targets aspiring musicians and fans of feel-good success stories, particularly those interested in the R&B/soul music genre. The video's raw, authentic feel enhances engagement, making the artist relatable and inspiring. Leveraging this content for ads should focus on the dream-come-true narrative, emphasizing the accessibility of music promotion through platforms like YouTube Shorts. Partnering with YouTube Music could amplify the message and broaden reach.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "bro this song>>> #fyp #newmusic #stevelacy #artist #stephanie #beabadoobee #laufey #music",
                "username": "nafeesisboujee",
                "timestamp": "2024-12-23T19:04:51+0000",
                "permalink": "https://www.instagram.com/reel/DD7pJNxSiwk/",
                "engagement": 8860
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video features a young man lip-syncing to an indie pop song, presumably Steve Lacy given the hashtags. He's standing beneath the Washington Square Arch in New York City at sunset, with other people visible in the background. The video includes overlaid text conveying a humorous, relatable scenario about texting a girl. The video is filmed with a slightly vintage or filtered aesthetic.",
                    "visual_elements": [
                        "Washington Square Arch as a recognizable landmark",
                        "Warm sunset lighting",
                        "Man wearing glasses and a Ralph Lauren sweater",
                        "Lo-fi aesthetic and filter",
                        "On-screen text overlay for comedic effect",
                        "Casual urban setting with blurred background figures"
                    ],
                    "themes_topics": [
                        "Indie pop music",
                        "College students",
                        "Urban exploration",
                        "Relationship ambiguity",
                        "Gen Z humor",
                        "Emerging artists",
                        "Casual fashion",
                        "Nostalgia",
                        "Candid moments"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Ages 16-25",
                        "College students",
                        "Urban residents",
                        "Gen Z",
                        "Millennials",
                        "United States and English-speaking countries"
                    ],
                    "psychographics": [
                        "Enjoy indie pop and alternative music",
                        "Value authenticity and relatable content",
                        "Active on TikTok and Instagram",
                        "Interested in fashion and urban culture",
                        "Humorous and enjoy meme culture",
                        "Appreciate vintage aesthetics",
                        "Seek shareable content"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "Laufey",
                        "Ralph Lauren",
                        "A24 (for film aesthetic)",
                        "Indie music blogs",
                        "Urban Outfitters"
                    ],
                    "topics": [
                        "Indie pop",
                        "Bedroom pop",
                        "College life",
                        "New York City",
                        "Urban fashion",
                        "Relatable humor",
                        "Music discovery",
                        "Aesthetic filters",
                        "Social media trends",
                        "Relationship memes"
                    ]
                },
                "detailed_summary": "This Instagram reel features a young man lip-syncing to a popular song in front of a well-known landmark. The video's aesthetic, combined with the lighthearted caption and hashtags, suggests it's aimed at Gen Z and young millennial audiences who enjoy indie music and relatable relationship content. Targeting ads towards college students and urban dwellers who enjoy music and shareable content may be a successful approach. Influencer marketing with similar emerging artists could also be effective.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "she still keeps on texting me 😭 #fyp #music #stevelacy #beabadoobee #artist #laufey #newmusic",
                "username": "nafeesisboujee",
                "timestamp": "2025-01-17T18:45:23+0000",
                "permalink": "https://www.instagram.com/reel/DE7-5woSd_w/",
                "engagement": 8150
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "A young man is walking down a brick-paved street lined with old buildings. He is wearing a patterned cardigan, light-colored jeans, and gloves, and holding a smartphone. He looks at the phone, reacting to a text message appearing on the screen. A second person, presumably the same individual, is walking in the background further down the street.",
                    "visual_elements": [
                        "Brick-paved street creates vintage urban aesthetic",
                        "Patterned cardigan and light-colored jeans suggesting indie/alternative fashion sense",
                        "Smartphone displaying a text message",
                        "Gloves suggest a colder climate or season (possibly fall/winter)",
                        "Buildings and architecture suggest an older neighborhood or city setting",
                        "Warm color palette with emphasis on earth tones",
                        "Blur effect or shallow depth of field",
                        "Person walking away in the background suggests movement or narrative progression"
                    ],
                    "themes_topics": [
                        "Relationship dynamics",
                        "Modern dating",
                        "Texting anxiety",
                        "Indie music",
                        "Urban fashion",
                        "Self-expression",
                        "Nostalgia (implied through fashion/setting)",
                        "Pining/Unrequited Affection",
                        "Youth culture"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Ages 18-25",
                        "Gender-inclusive, slightly skewed towards female",
                        "Urban residents",
                        "Students or young professionals"
                    ],
                    "psychographics": [
                        "Interested in indie/alternative music",
                        "Value authenticity and emotional honesty",
                        "Engaged in modern relationship culture",
                        "Fashion-conscious; follows vintage and indie trends",
                        "Active on social media; follows trends and memes",
                        "May experience anxiety related to dating and relationships",
                        "Expressive and open about their emotions",
                        "Appreciate vintage aesthetics"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "Laufey",
                        "Clairo",
                        "Phoebe Bridgers",
                        "Urban Outfitters",
                        "ASOS",
                        "Depop",
                        "Spotify",
                        "Apple Music"
                    ],
                    "topics": [
                        "Indie music",
                        "Alternative fashion",
                        "Modern dating",
                        "Texting culture",
                        "Relationship anxiety",
                        "Urban exploration",
                        "Vintage aesthetics",
                        "Self-expression",
                        "Instagram reels",
                        "TikTok trends"
                    ]
                },
                "detailed_summary": "This Instagram reel captures a young man navigating modern relationship dynamics and the anxieties associated with digital communication, specifically texting. The vintage urban setting, combined with trendy indie-inspired fashion, suggests an audience that appreciates both nostalgia and contemporary self-expression. The video utilizes a simple narrative of receiving a text message to convey a relatable emotional state, likely appealing to young adults experiencing similar situations. The strategic use of music and hashtags (including references to popular indie artists like Steve Lacy, Beabadoobee, and Laufey) strengthens its appeal within that community. The content would resonate with brands and products that cater to the indie music scene, vintage fashion, and expressive personal technology.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "Stephanie, Maddie now Hailey?!!?! #fyp #stevelacy #beabadoobee #newmusic #music #artist",
                "username": "nafeesisboujee",
                "timestamp": "2025-02-26T18:41:11+0000",
                "permalink": "https://www.instagram.com/reel/DGi-L-ePncL/",
                "engagement": 6406
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "A young man is lip-syncing and acting out a popular song, changing names in the lyrics from 'Stephanie' and 'Maddie' to 'Hailey'. He's making expressive hand gestures, including forming a heart shape with his hands. The setting is his bedroom, with a closet, bed, and posters visible in the background.",
                    "visual_elements": [
                        "The creator is wearing a green plaid puffer jacket and glasses.",
                        "Background includes a bed with a red light behind it and a closet with clothes visible.",
                        "Posters on the wall add a personal touch to the setting.",
                        "Text overlay showing the lyrics with changing names.",
                        "Direct eye contact and expressive facial expressions enhance engagement."
                    ],
                    "themes_topics": [
                        "Popular song trends on TikTok/Instagram",
                        "Relatability in romantic relationships",
                        "Humorous interpretation of song lyrics",
                        "DIY music videos/lip-sync performances",
                        "Gen Z humor and social media trends"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Gen Z (16-24 years old)",
                        "Young Millennials (25-30 years old)",
                        "Primarily English-speaking regions",
                        "Urban and suburban areas",
                        "High social media usage"
                    ],
                    "psychographics": [
                        "Interested in pop culture and music trends",
                        "Value humor and relatable content",
                        "Active on TikTok and Instagram",
                        "Engage with DIY content creation",
                        "Follow meme and trend-based accounts",
                        "Interested in romantic relationships and dating",
                        "Expressive and comfortable with online performance"
                    ],
                    "public_figures_brands": [
                        "Steve Lacy",
                        "Beabadoobee",
                        "TikTok influencers",
                        "Instagram meme accounts",
                        "Popular music artists on Gen Z playlists"
                    ],
                    "topics": [
                        "TikTok trends",
                        "Instagram reels",
                        "Lip-sync videos",
                        "Gen Z humor",
                        "Relationship memes",
                        "Steve Lacy music",
                        "Beabadoobee music",
                        "Viral song challenges",
                        "Relatable content",
                        "DIY music videos"
                    ]
                },
                "detailed_summary": "This Instagram reel features a young man lip-syncing and humorously adapting a popular song, changing names in the lyrics to create a relatable scenario. The content targets Gen Z and younger millennials, who are familiar with viral music trends and enjoy relatable relationship content. By leveraging popular songs and adding a personal twist, the creator taps into the audience's desire for humor and shared experiences. Marketing strategies should focus on short-form video platforms, highlighting relatability, humor, and user-generated content potential. The use of trending songs and personalized interpretations is likely to drive engagement within this demographic.",
                "status": "finished"
            }
        },
        {
            "postMetadata": {
                "caption": "STEPHANIE MUSIC VIDEO… TMRW SEE YOU THERE\n###\n\nkirchfilmss\ncityislandprod",
                "username": "nafeesisboujee",
                "timestamp": "2025-02-18T19:51:21+0000",
                "permalink": "https://www.instagram.com/reel/DGOfum2BFx3/",
                "engagement": 6068
            },
            "analysis": {
                "content_breakdown": {
                    "video_narrative": "The video shows several quick cuts of people walking around in an urban setting, walking through a crosswalk, and scenes inside a store. There are people posing, suggesting a music video shoot. The overall feel is raw and energetic, indicating the music video will have similar style.",
                    "visual_elements": [
                        "Urban street scenes",
                        "Crosswalks",
                        "Store interiors",
                        "Fashionable urban attire",
                        "Candid shots of people",
                        "Quick cuts and dynamic angles",
                        "Gloomy atmosphere"
                    ],
                    "themes_topics": [
                        "Music video launch",
                        "Urban lifestyle",
                        "Youth culture",
                        "Creative expression",
                        "Indie music",
                        "City exploration"
                    ]
                },
                "target_audience_analysis": {
                    "demographics": [
                        "Gen Z (16-24 years old)",
                        "Urban dwellers",
                        "Trendsetters",
                        "Art and music enthusiasts",
                        "Gender-inclusive"
                    ],
                    "psychographics": [
                        "Value creative expression",
                        "Interested in indie music",
                        "Active on social media",
                        "Follow fashion trends",
                        "Appreciate raw and authentic content",
                        "Seek unique experiences",
                        "Support emerging artists"
                    ],
                    "public_figures_brands": [
                        "Indie music artists",
                        "Streetwear brands",
                        "Youth-focused influencers",
                        "Music video directors",
                        "Urban art collectives"
                    ],
                    "topics": [
                        "Indie music scene",
                        "Urban fashion trends",
                        "Music video production",
                        "Youth culture and lifestyle",
                        "Emerging artists",
                        "DIY music videos",
                        "Street photography",
                        "Creative arts",
                        "Local music venues",
                        "Music discovery platforms"
                    ]
                },
                "detailed_summary": "This Instagram reel promotes the upcoming launch of Stephanie's music video, featuring quick cuts of urban settings and youthful energy. It appeals to viewers interested in indie music and urban lifestyles. Marketing efforts should focus on music blogs, social media influencers, and youth-oriented lifestyle brands to maximize reach and engagement. Highlighting the unique blend of street style and artistic expression can draw in a broader audience.",
                "status": "finished"
            }
        }
    ],
    "recommendations": {
        "contentThemes": [
            "Student life and struggles",
            "Music creation and promotion",
            "Relationship issues and dating",
            "Gen Z humor and relatability",
            "Indie pop music and aesthetics",
            "Urban culture and lifestyle",
            "Social media trends",
            "Nostalgia and youthful expression",
            "Success and achievement in the music industry",
            "Appreciation of music and aesthetics"
        ],
        "visualElements": [
            "Urban settings (Times Square, city streets)",
            "Casual and trendy fashion",
            "DIY music video aesthetics",
            "Use of text overlays and captions",
            "Bright and vibrant colors",
            "Dynamic camera angles and transitions",
            "Relatable and humorous facial expressions",
            "Aesthetic filters and effects",
            "Visual references to popular songs and artists",
            "Showcasing the music production process"
        ],
        "audioElements": [
            "Use of popular song snippets (Steve Lacy, Beabadoobee, Laufey)",
            "Emphasis on catchy and trending music",
            "Clear and audible vocals",
            "Background music that complements the video's mood",
            "Sound effects to enhance humor or relatability"
        ],
        "contentPatterns": [
            "Relatable student life situations",
            "Humorous takes on everyday experiences",
            "Promotion of original music",
            "References to popular songs and artists",
            "Use of trending hashtags and challenges",
            "Consistent character or theme (e.g., 'Stephanie')",
            "Short-form video format (TikTok/Instagram Reels)",
            "Urban settings and fashion",
            "DIY music production and promotion",
            "Engagement with audience through questions and polls"
        ],
        "recommendations": [
            "Maintain consistency in posting schedule to keep audience engaged.",
            "Continue using trending audio and hashtags to increase discoverability.",
            "Encourage user-generated content by creating challenges or prompts.",
            "Collaborate with other creators to reach a wider audience.",
            "Focus on high-quality video and audio production.",
            "Respond to comments and messages to build a stronger connection with fans.",
            "Experiment with different video formats and styles to keep content fresh.",
            "Analyze audience engagement metrics to identify what resonates most.",
            "Develop a strong brand identity and visual aesthetic.",
            "Promote content across multiple platforms (Instagram, TikTok, YouTube)."
        ],
        "contentIdeas": [
            "Collaborate with other student artists or musicians",
            "Create behind-the-scenes content of music production",
            "Share personal stories and experiences related to student life",
            "Incorporate trending challenges and memes into music-related content",
            "Host Q&A sessions with fans about music and creative process",
            "Create tutorials or tips for aspiring musicians",
            "Showcase the creative process behind music video production",
            "Develop a series based on relatable student struggles",
            "Create content around specific songs or artists that resonate with the audience",
            "Explore different musical genres and styles"
        ],
        "audienceInsights": {
            "demographics": [
                "Ages 16-24 (Gen Z)",
                "High school and college students",
                "Urban and suburban residents",
                "English-speaking countries (US, UK, Canada, Australia)",
                "Gender-inclusive"
            ],
            "interests": [
                "Indie pop music",
                "Bedroom pop aesthetic",
                "Emerging artists (Steve Lacy, Beabadoobee, Laufey)",
                "Music production and creation",
                "Fashion and personal style",
                "Urban culture",
                "Social media trends",
                "Relatable relationship issues",
                "Student life",
                "DIY projects"
            ],
            "behaviors": [
                "Active social media users (Instagram, TikTok, YouTube)",
                "Engage with music-related content",
                "Interested in DIY and creative projects",
                "Follow music trends and emerging artists",
                "Participate in online challenges and memes"
            ]
        }
    }
}

interface MaestroInstagramPostsState {
    // State
    isLoadingMaestroInstagramPosts: boolean
    igUsernameOrUrl: string
    maestroInstagramPostsData: any
    isShowMaestroInstagramInputModal: boolean
    isShowMaestroInstagramResultsModal: boolean

    // Actions
    setIsLoadingMaestroInstagramPosts: (loading: boolean) => void
    setIgUsernameOrUrl: (igUsernameOrUrl: string) => void
    setMaestroInstagramPostsData: (postsData: any) => void
    setIsShowMaestroInstagramInputModal: (isShow: boolean) => void
    setIsShowMaestroInstagramResultsModal: (isShow: boolean) => void

    // Methods
    postAnalyzeInstagramPosts: (igUsernameOrUrl?: string) => void
}

const useMaestroInstagramPosts = create<MaestroInstagramPostsState>()(
    immer((set, get) => ({
        // State
        isLoadingMaestroInstagramPosts: false,
        igUsernameOrUrl: '',
        maestroInstagramPostsData: null,
        isShowMaestroInstagramInputModal: false,
        isShowMaestroInstagramResultsModal: false,

        // Actions
        setIsLoadingMaestroInstagramPosts: (loading) => { set((state) => { state.isLoadingMaestroInstagramPosts = loading }) },
        setIgUsernameOrUrl: (igUsernameOrUrl) => { set((state) => { state.igUsernameOrUrl = igUsernameOrUrl }) },
        setMaestroInstagramPostsData: (maestroInstagramPostsData) => { set((state) => { state.maestroInstagramPostsData = maestroInstagramPostsData }) },
        setIsShowMaestroInstagramInputModal: (isShow) => { set((state) => { state.isShowMaestroInstagramInputModal = isShow }) },
        setIsShowMaestroInstagramResultsModal: (isShow) => { set((state) => { state.isShowMaestroInstagramResultsModal = isShow }) },

        // Methods
        postAnalyzeInstagramPosts: async (igUsernameOrUrl?: string) => {
            if (!igUsernameOrUrl) {
                return;
            }

            let payload: { profileUrl?: string; profileUsername?: string } = {}

            if (igUsernameOrUrl.includes('instagram.com')) {
                payload = {
                    profileUrl: igUsernameOrUrl
                }
            } else {
                payload = {
                    profileUsername: igUsernameOrUrl
                }
            }

            if (IS_MOCK) {
                set((state) => {
                    state.maestroInstagramPostsData = MAESTRO_INSTAGRAM_POSTS_MOCK_DATA
                })
                return;
            }

            set((state) => {
                state.isLoadingMaestroInstagramPosts = true
            })

            try {
                const response = await Axios.post('agents/analyze-instagram-videos', payload)
                const data = response.data

                set((state) => {
                    state.maestroInstagramPostsData = data
                })
            } catch (error) {
                console.error('Error sending message:', error)
            } finally {
                set((state) => { state.isLoadingMaestroInstagramPosts = false })
            }
        },
    }))
)

export default useMaestroInstagramPosts
